import utils from "./utils";

export default {
  // 완전 기본 차트 Layout 셋팅
  setDefaultLayout(id) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
  setDefaultTimeLayout(id, datacnt, showtimecnt) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickmode: "auto",
        nticks: datacnt > showtimecnt ? showtimecnt : datacnt,
        tickformat: "%Y-%m-%d %H:%M:%S",
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
  setDefaultDualAxisLayout(id) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      yaxis2: {
        zeroline: false,
        color: "#b4b7bd",
        overlaying: "y",
        side: "right",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
  setDefaultDualAxisTimeLayout(id, datacnt, showtimecnt) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickmode: "auto",
        nticks: datacnt > showtimecnt ? showtimecnt : datacnt,
        tickformat: "%Y-%m-%d %H:%M:%S",
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      yaxis2: {
        zeroline: false,
        color: "#b4b7bd",
        overlaying: "y",
        side: "right",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
  setDefaultTimeAndDoubleYAxisAutoSizeLayout(paperBgcolor, plotBgcolor) {
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#c5c8d0",
        tickmode: "auto",
        tickformat: "%Y-%m-%d %H:%M:%S",
      },
      yaxis: {
        zeroline: false,
        color: "#c5c8d0",
      },
      yaxis2: {
        zeroline: false,
        color: "#c5c8d0",
        overlaying: "y",
        side: "right",
      },
      paper_bgcolor: paperBgcolor ? paperBgcolor : "#0e131f",
      plot_bgcolor: plotBgcolor ? plotBgcolor : "#0e131f",
      autosize: true,
      annotations: [],
    };
    return layout;
  },
  // 옵션이 들어간 차트 Layout 셋팅
  setLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          color: "#b4b7bd",
        },
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      showlegend: utils.chkNull(options.showlegend, true),
      annotations: [],
    };
    // x축, y축 tick 표시 개수 제한
    if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showxaxiscnt) !== null
    ) {
      layout.xaxis.tickmode = "auto";
      layout.xaxis.nticks =
        options.datacnt > options.showxaxiscnt
          ? options.showxaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxiscnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxiscnt
          ? options.showyaxiscnt
          : options.datacnt;
    }
    // margin 셋팅(없으면 default)
    if (utils.chkNull(options.margin) !== null) {
      layout.margin = options.margin;
    }
    // legend 셋팅
    if (
      utils.chkNull(options.showlegend, true) &&
      utils.chkNull(options.legend) !== null
    ) {
      layout.legend = options.legend;
    }
    // Annotation Xaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.xaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("x", options.annotation.xaxis)
      );
    }
    // Annotation Yaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y", options.annotation.yaxis)
      );
    }
    return layout;
  },
  setDefaultDateLayout(id) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        type: "category",
        tickformat: "%Y-%m-%d",
        tickfont: {
          size: null,
        },
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
  setTimeLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickformat: "%Y-%m-%d %H:%M:%S",
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    // x축, y축 tick 표시 개수 제한
    if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showxaxiscnt) !== null
    ) {
      layout.xaxis.tickmode = "auto";
      layout.xaxis.nticks =
        options.datacnt > options.showxaxiscnt
          ? options.showxaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxiscnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxiscnt
          ? options.showyaxiscnt
          : options.datacnt;
    }
    // margin 셋팅(없으면 default)
    if (utils.chkNull(options.margin) !== null) {
      layout.margin = options.margin;
    }
    // legend 셋팅
    if (
      utils.chkNull(options.showlegend, true) &&
      utils.chkNull(options.legend) !== null
    ) {
      layout.legend = options.legend;
    }
    // Annotation Xaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.xaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("x", options.annotation.xaxis)
      );
    }
    // Annotation Yaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y", options.annotation.yaxis)
      );
    }
    return layout;
  },
  setPieLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    var layout = {
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: utils.chkNum(options.width, Math.floor(tmpLayout.clientWidth)),
      height: utils.chkNum(
        options.height,
        Math.floor(tmpLayout.clientHeight - 10)
      ),
      showlegend: utils.chkNull(options.showlegend, true),
      annotations: [],
    };
    if (utils.chkNull(options.margin) !== null) {
      layout.margin = options.margin;
    }
    if (utils.chkNull(options.annotation) !== null) {
      layout.annotations.push(this.setChartAnnotation("x", options.annotation));
    }
    return layout;
  },
  setDualAxisLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      yaxis2: {
        zeroline: false,
        color: "#b4b7bd",
        overlaying: "y",
        side: "right",
        tickfont: {
          size: null,
        },
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    if (utils.chkNull(options.margin) !== null) {
      layout.margin = options.margin;
    }
    if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showxaxiscnt) !== null
    ) {
      layout.xaxis.tickmode = "auto";
      layout.xaxis.nticks =
        options.datacnt > options.showxaxiscnt
          ? options.showxaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxiscnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxiscnt
          ? options.showyaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxis2cnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxis2cnt
          ? options.showyaxis2cnt
          : options.datacnt;
    }
    // Annotation Xaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.xaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("x", options.annotation.xaxis)
      );
    }
    // Annotation Yaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y", options.annotation.yaxis)
      );
    }
    // Annotation Yaxis2 Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis2) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y2", options.annotation.yaxis2)
      );
    }
    return layout;
  },
  setDualAxisTimeLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickformat: "%Y-%m-%d %H:%M:%S",
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
      },
      yaxis2: {
        zeroline: false,
        color: "#b4b7bd",
        overlaying: "y",
        side: "right",
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showxaxiscnt) !== null
    ) {
      layout.xaxis.tickmode = "auto";
      layout.xaxis.nticks =
        options.datacnt > options.showxaxiscnt
          ? options.showxaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxiscnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxiscnt
          ? options.showyaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxis2cnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxis2cnt
          ? options.showyaxis2cnt
          : options.datacnt;
    }
    // Annotation Xaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.xaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("x", options.annotation.xaxis)
      );
    }
    // Annotation Yaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y", options.annotation.yaxis)
      );
    }
    // Annotation Yaxis2 Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis2) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y2", options.annotation.yaxis2)
      );
    }
    return layout;
  },
  setDualAxisDateLayout(id, options) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      xaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickformat: "%Y-%m-%d",
        tickfont: {
          size: null,
        },
      },
      yaxis: {
        zeroline: false,
        color: "#b4b7bd",
        tickfont: {
          size: null,
        },
      },
      yaxis2: {
        zeroline: false,
        color: "#b4b7bd",
        overlaying: "y",
        side: "right",
        tickfont: {
          size: null,
        },
      },
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      showlegend: utils.chkNull(options.showlegend, true),
      annotations: [],
    };
    // axis tick 표현 개수 셋팅
    if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showxaxiscnt) !== null
    ) {
      layout.xaxis.tickmode = "auto";
      layout.xaxis.nticks =
        options.datacnt > options.showxaxiscnt
          ? options.showxaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxiscnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxiscnt
          ? options.showyaxiscnt
          : options.datacnt;
    } else if (
      utils.chkNull(options.datacnt) !== null &&
      utils.chkNull(options.showyaxis2cnt) !== null
    ) {
      layout.yaxis.tickmode = "auto";
      layout.yaxis.nticks =
        options.datacnt > options.showyaxis2cnt
          ? options.showyaxis2cnt
          : options.datacnt;
    }
    // margin 셋팅(없으면 default)
    if (utils.chkNull(options.margin) !== null) {
      layout.margin = options.margin;
    }
    // legend 셋팅
    if (
      utils.chkNull(options.showlegend, true) &&
      utils.chkNull(options.legend) !== null
    ) {
      layout.legend = options.legend;
    }
    // Annotation Xaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.xaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("x", options.annotation.xaxis)
      );
    }
    // Annotation Yaxis Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y", options.annotation.yaxis)
      );
    }
    // Annotation Yaxis2 Setting
    if (
      utils.chkNull(options.annotation) !== null &&
      utils.chkNull(options.annotation.yaxis2) !== null
    ) {
      layout.annotations.push(
        this.setChartAnnotation("y2", options.annotation.yaxis2)
      );
    }
    return layout;
  },
  // Make Chart Annotations
  setChartAnnotation(axis, param) {
    return {
      xref: "paper",
      yref: "paper",
      x: utils.chkNum(
        param.x,
        axis === "x" ? 0.5 : axis === "y" ? -0.14 : 1.05
      ),
      y: utils.chkNum(param.y, axis === "x" ? -0.15 : 0.5),
      text: param.text,
      textangle: axis === "x" ? 0 : axis === "y" ? -90 : 90,
      font: {
        family: "Noto Sans KR",
        size: param.fontSize ? param.fontSize : 17,
        color: param.color ? param.color : "#b4b7bd",
        weight: "normal",
      },
      showarrow: false,
    };
  },
  setDefault3dLayout(id) {
    var tmpLayout = document.getElementById(id);
    let layout = {
      scene: {
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          range: [-1, 11],
          font: {
            color: "#b4b7bd",
          },
        },
        yaxis: {
          zeroline: false,
          color: "#b4b7bd",
          range: [-1, 2],
          font: {
            color: "#b4b7bd",
          },
        },
        zaxis: {
          zeroline: false,
          color: "#b4b7bd",
          range: [-1, 1],
          font: {
            color: "#b4b7bd",
          },
        },
      },
      margin: {
        l: 0,
        r: 0,
        t: 0,
        b: 0,
        pad: 0,
      },
      font: {
        color: "#b4b7bd",
      },
      updatemenus: [],
      paper_bgcolor: "#283046",
      plot_bgcolor: "#283046",
      width: Math.floor(tmpLayout.clientWidth - 1),
      height: Math.floor(tmpLayout.clientHeight - 1),
      annotations: [],
    };
    return layout;
  },
};



// WEBPACK FOOTER //
// ./src/components/common/chartUtil.js